interface DashboardCsvDimensionColumn {
  type: 'dimension'
  title: string
  bodyCells: string[]
}

interface DashboardCsvKpiColumn {
  type: 'kpi'
  title: string
  blockLabels: string[]
  actualBodyCells: string[]
  goalBodyCells: string[]
}

export type DashboardCsvColumn = DashboardCsvDimensionColumn | DashboardCsvKpiColumn

type KpiRole = 'actual' | 'goal'

type RoleLabels = Record<KpiRole, string>

interface DashboardCsvData {
  headers: string[]
  rows: string[][]
}

const transpose = (values: string[][]): string[][] =>
  Array.from({ length: values[0]?.length ?? 0 }, (_, rowIndex) => values.map((column) => column[rowIndex] ?? ''))

export const generateDashboardCsvData = (
  columns: DashboardCsvColumn[],
  shouldIncludeGoal: boolean,
  roleLabels: RoleLabels,
): DashboardCsvData => {
  const roles: KpiRole[] = shouldIncludeGoal ? ['actual', 'goal'] : ['actual']
  const headerDepth = Math.max(0, ...columns.map((column) => (column.type === 'kpi' ? column.blockLabels.length : 0)))
  const outputColumns = columns.flatMap((column) => {
    if (column.type === 'dimension') {
      return [
        {
          headerCells: [...Array.from({ length: headerDepth }, () => ''), column.title],
          bodyCells: column.bodyCells,
        },
      ]
    }

    return roles.map((role) => ({
      headerCells: [
        ...Array.from({ length: headerDepth }, (_, index) => column.blockLabels[index] ?? ''),
        `${column.title} (${roleLabels[role]})`,
      ],
      bodyCells: role === 'actual' ? column.actualBodyCells : column.goalBodyCells,
    }))
  })
  const matrix = transpose(outputColumns.map((column) => [...column.headerCells, ...column.bodyCells]))

  return {
    headers: matrix[0] ?? [],
    rows: matrix.slice(1),
  }
}
